import styles from './DetailSkeleton.module.css';

/**
 * 체험단 상세 로딩 자리표시자.
 * 상세는 검색·공유로 유입되는 첫 화면이라 빈 글씨 한 줄로 두면 체감이 크게 나쁘다.
 * 실제 레이아웃(갤러리 + 우측 패널)과 같은 골격이라 로드 후 요소가 튀지 않는다.
 */
export default function DetailSkeleton() {
  return (
    <div className={styles.page} aria-hidden="true">
      <div className={styles.inner}>
        <div className={`${styles.crumb} ${styles.shimmer}`} />

        <div className={styles.top}>
          <div className={`${styles.gallery} ${styles.shimmer}`} />

          <div className={styles.panel}>
            <div className={`${styles.brand} ${styles.shimmer}`} />
            <div className={`${styles.title} ${styles.shimmer}`} />
            <div className={`${styles.titleShort} ${styles.shimmer}`} />

            <div className={styles.badges}>
              <div className={`${styles.badge} ${styles.shimmer}`} />
              <div className={`${styles.badge} ${styles.shimmer}`} />
            </div>

            <div className={styles.info}>
              {Array.from({ length: 5 }, (_, i) => (
                <div className={styles.infoRow} key={i}>
                  <div className={`${styles.infoLabel} ${styles.shimmer}`} />
                  <div className={`${styles.infoValue} ${styles.shimmer}`} />
                </div>
              ))}
            </div>

            <div className={`${styles.cta} ${styles.shimmer}`} />
          </div>
        </div>
      </div>
    </div>
  );
}
